import gql from "graphql-tag";

export const FILL_OUT_ADMIN_SERVICE_ORDER = gql`
  mutation fillOutAdminServiceOrder($companyCreationId: ID, $orderId: ID) {
    fillOutAdminServiceOrder(companyCreationId: $companyCreationId, orderId: $orderId)
  }
`;
